import {Box, Text} from "@chakra-ui/react";

export default function Signature() {
    return (
        <Box bg='talesBlack' m='auto' p='5px' >
            <Text color='talesYellow.500' textAlign='center' fontFamily='subtitle' fontSize='xs'>Made with 🍕 by EC</Text>
        </Box>
    )
}